import axios from 'axios'
import qs from 'qs'
import { Notification } from 'element-ui'
import store from '@/store'
import Storage from '@/utils/storagehandle'

// 清除登录态并统一跳转登录页,重新登录
function redirectToLogin() {
  // 清除本地登录态(token/用户信息)
  Storage.removeItem('token')
  store.commit('user/SET_TOKEN', '')
  // 路由为 hash 模式,整页跳 /login 后端无此资源会 404,统一跳 /#/login
  if (window.location.hash.indexOf('/login') === -1) {
    window.location = '/#/login'
  }
}

// 判断后端返回的是否为无权限错误
function isNoPermission(data) {
  if (!data) return false
  // 无权限提示文案可能在 msg 或 state 字段,业务码不固定,以文案为准
  const tip = data.msg || data.state || ''
  return tip.indexOf('没有权限') !== -1
}

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = '/api'
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = '/'
}

axios.interceptors.request.use(
  (config) => {
    // console.log(config)
  
    if (store.state.user.token) {
      config.headers.common.token = store.state.user.token
      // config.headers={}
    }

    // if (config.data && Object.keys(config.data).length == 0) {
    //   delete config.data
    // }
// console.log(config)
    return config
  },

  (error) => {
    Notification.notify({
      type: 'error',
      message: '加载超时',
      duration: 5000,
      offset: 70,
    })
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code && res.code !== 0) {
      Notification({
        type: 'error',
        message: res.state || res.msg,
      })

      // 后端返回无权限业务码(code 500):清除登录态,统一跳转登录页重新登录
      if (isNoPermission(res)) {
        redirectToLogin()
      }

      // return  Promise.reject(new Error(res.msg ))
      return ""
    } else {
      return res
    }
  },
  (error) => {
    // 后端以 HTTP 错误状态返回无权限信息时,同样统一跳转登录页
    if (isNoPermission(error.response && error.response.data)) {
      redirectToLogin()
    }
    // HTTP 状态码在 error.response.status 上,不在 error.status 上
    const status = error.response ? error.response.status : null
    if (status === 401) {
      // 401 未认证:清除本地登录态(token/用户信息),跳转登录页
      redirectToLogin()
    } else if (status === 403) {
      // 403 无权限:跳转登录页
      Notification({
        type: 'error',
        message: '登录过期，请重新登录',
        duration: 5000,
        offset: 70,
      })
      redirectToLogin()
    } else if (status === 404) {
      // console.log(333)
      Notification({
        type: 'error',
        message: '网络请求不存在',
        duration: 5000,
        offset: 70,
      })
    } else if (status) {
      // console.log(444)
      Notification({
        type: 'error',
        message: error.msg,
        duration: 5000,
        offset: 70,
      })
    } else {
      console.log(555)
      if (JSON.stringify(error).includes('timeout')) {
        
        Notification({
          type: 'error',
          message: '服务器响应超时，请刷新当前页面',
          duration: 5000,
          offset: 70,
        })
      }
    }
    console.log(error)

    return ""
  }
)

export function get(url, params) {
  // console.log(url)
  // console.log(params)
  return new Promise((resolve, reject) => {
    axios
      .get(url + '?' + qs.stringify(params, { allowDots: true }))
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        // console.log(err)
        reject(err)
      })
  })
}
export function qget(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url + '?' + qs.stringify(params, { allowDots: true }))
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function qpost(url, params) {
  return new Promise((resolve, reject) => {
    // console.log(url,params)
    axios
      .post(url, qs.stringify(params, { allowDots: true }))
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}


// // 上传文件,
// export function reqUploadImg(file, user_id) {
//   return axios({
//     url: '/uploadImg',
//     method: 'POST',
//     Headers: {
//       "content-type": "multipart/form-data",
//     },
//     data: file,
//     params: { user_id }
//   })
// }


export function qdpost(url, params) {
  return new Promise((resolve, reject) => {
    // console.log(url,params)
    axios
      .post(url, params,{headers: {
              "Content-Type": "multipart/form-data",
            }
        })
        .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}



export function qpdpost(url, params) {
  return new Promise((resolve, reject) => {
    // console.log(url,params)
    axios
      .post(url, qs.stringify(params, { allowDots: true }),{
        responseType: "blob",//这里一定要设置，否则返回的流是乱码，下载之后文件是空白的
    })
        .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}




export function qdget(url,params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url+'?' + qs.stringify(params, { allowDots: true }),{
        responseType: "blob",//这里一定要设置，否则返回的流是乱码，下载之后文件是空白的
    })
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}




export function qapost(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        url,
        qs.stringify(params, { arrayFormat: 'indices', allowDots: true })
      )
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function qput(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(
        url,
        qs.stringify(params, { arrayFormat: 'indices', allowDots: true })
      )
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export function remove(url, params) {
  // console.log(url)
  // console.log(params)
  return new Promise((resolve, reject) => {
    axios
      .delete(url, 
        { params: params })
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default axios
